(function () {
  function parseTargetDate(value) {
    if (!value) return null;

    var normalized = value.trim().replace(' ', 'T');
    var target = new Date(normalized);

    if (Number.isNaN(target.getTime()) && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
      target = new Date(value.trim() + 'T00:00:00');
    }

    return Number.isNaN(target.getTime()) ? null : target;
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initCountdown(countdown) {
    var target = parseTargetDate(countdown.dataset.countdownTarget);
    var days = countdown.querySelector('[data-countdown-days]');
    var hours = countdown.querySelector('[data-countdown-hours]');
    var minutes = countdown.querySelector('[data-countdown-minutes]');
    var seconds = countdown.querySelector('[data-countdown-seconds]');

    if (!target || !days || !hours || !minutes || !seconds) return;

    function render() {
      var distance = Math.max(0, target.getTime() - Date.now());
      var totalSeconds = Math.floor(distance / 1000);
      var remainingDays = Math.floor(totalSeconds / 86400);
      var remainingHours = Math.floor((totalSeconds % 86400) / 3600);
      var remainingMinutes = Math.floor((totalSeconds % 3600) / 60);
      var remainingSeconds = totalSeconds % 60;

      days.textContent = String(remainingDays);
      hours.textContent = pad(remainingHours);
      minutes.textContent = pad(remainingMinutes);
      seconds.textContent = pad(remainingSeconds);

      if (distance === 0) window.clearInterval(timer);
    }

    render();
    var timer = window.setInterval(render, 1000);
  }

  function init() {
    document.querySelectorAll('[data-password-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
